import { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  Button,
  AppBar,
  Toolbar,
  CircularProgress,
  Pagination,
  Stack,
  Autocomplete,
  Grid,
  TextField,
  IconButton,
  InputLabel,
  Checkbox,
  Grid2,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";
import Colors from "../../assets/styles";
import AuthServices from "../../apis/AuthServices";
import moment from "moment";
import SimpleDialog from "../../components/Modal/index";
import { Controller, useForm } from "react-hook-form";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { ErrorToaster, SuccessToaster } from "../../components/toaster";
import AddIcon from "@mui/icons-material/Add";


export default function LiveTrains() {
  const [liveTrains, setLiveTrains] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [isLoading, setIsLoading] = useState(false);
  const [stations, setStations] = useState([]);
  const [trains, setTrains] = useState([]);
  const [openInterChange, setOpenInterChange] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [selectedTrain, setSelectedTrain] = useState(false);
  const [editDialog, setEditDialog] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  
  const [trainRoutes, setTrainRoutes] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [direction, setDirection] = useState("");
  const [trainId, setTrainId] = useState("");
  const [checkbox, setCheckBox] = useState("");
  const [error, setError] = useState("");
  const [station, setStation] = useState([]);

  const [timeDelays, setTimeDelays] = useState([]);
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    register,
    reset,
    watch,
  } = useForm({
    defaultValues: {
        dayCount: 0,
      },
  });

  


  const getTrains = async () => {
    try {
      const result = await AuthServices.getTrains();
      // console.log(result);
      if (result.IsSuccess == true) {
        setTrains(result?.Response);
      }
    } catch (error) {
      // console.log(error);
    }
  };
 const getTrainsRoute = async () => {
    setIsLoading(true)
  try {
    const result = await AuthServices.trainRoutes(trainId?.TrainId);
    console.log(result);
    if (result.IsSuccess === true && result.Response != null ) {
      
      const sortedRoutes = result.Response.sort((a, b) => a.OrderNumber - b.OrderNumber);
      setTrainRoutes(sortedRoutes);

      // Calculate delays
      const delays = sortedRoutes.map((route) => {
        if (route.DelayInMinutes >= 60) {
          const hours = Math.floor(route.DelayInMinutes / 60);
          const minutes = route.DelayInMinutes % 60;
          return `${hours} hr ${minutes} min`;
        }
        return `${route.DelayInMinutes} min`;
      });

      setTimeDelays(delays);
    }else{
        setTrainRoutes([])
    }
  } catch (error) {
    console.error("Error fetching train routes:", error);
  }
  finally{
    setIsLoading(false)
  }
};

  useEffect(() => {
    getTrains();
  }, []);
  useEffect(() => {
    getTrainsRoute();
    getStations()
  }, [trainId?.TrainId]);

  useEffect(() => {
    if (selectedTrain) {
      setValue("stationName", selectedTrain.StationName);
      setValue("arrivalTime", selectedTrain?.ArrivalTime);
      setValue("departureTime", selectedTrain?.DepartureTime);
      setValue("orderNo", selectedTrain?.OrderNumber);
      setValue("dayCount", selectedTrain?.DayCount);
      setCheckBox(selectedTrain.IsDayChanged === true);
    }
  }, [selectedTrain, stations, setValue]);
  console.log(selectedTrain , 'selectedTrain')

  const handleChange = (event) => {
    setTrainId(event);
    
  };
//   const onSubmit = async (formData) => {
//     // console.log(formData)
//     const obj = {
//       IsLive: checkbox,
//       IsUp: direction == true ? true : false,
//       TrainDescription: formData?.trainDesc,
//       TrainId: selectedTrain?.TrainId,
//       TrainName: formData?.name,
//       TrainNameUR: formData?.trainNameUr,
//       TrainNumber: formData?.trainNumber,
//       UpdatedBy: 1,
//     };
//     try {
//       const result = await AuthServices.updateTrainById(obj);
//       // console.log(result);
//       if (result.IsSuccess == true) {
//         getTrainsRoute();
//         setEditDialog(false);
//       }
//     } catch (error) {
//       // console.log(error);
//     }
//   };
  const deleteTrainRoute = async () => {
    try {
      const result = await AuthServices.deleteTrainRoute(trainId?.TrainId , selectedTrain?.StationDetailsId);
      // console.log(result);
      if (result.IsSuccess == true) {
        SuccessToaster("Deleted Successfully");
        getTrainsRoute();
        setDeleteDialog(false);
      }
    } catch (error) {
      ErrorToaster("Something went Wrong");
    }
  };
  const getStations = async () => {
    try {
      const result = await AuthServices.getStations();
      // console.log(result);
      if (result.IsSuccess == true) {
        setStations(result.Response);
      }
    } catch (error) {
      // console.log(error);
    }
  };
const EditTrainRoute =async(formData)=>{
    const obj = {
        trainId: formData?.trainName,
        stationDetailId: stations.find((s) =>  s.StationDetailsId === selectedTrain.StationDetailsId)?.StationDetailsId,
        arrivalTime: formData?.orderNo == 1 ? null : formData?.arrivalTime,
        departureTime: formData?.departureTime,
        orderNumber:Number( formData?.orderNo),
        IsDayChanged: checkbox,
        DayCount: formData?.dayCount,
      };
            //   console.log(obj);

      try {
              const result = await AuthServices.updateTrainRoute(obj);
              // console.log(result);
              if (result.IsSuccess == true) {
                getTrainsRoute();
                setEditDialog(false);
              }
            } catch (error) {
              // console.log(error);
            }
}
  return (
    <>
      <Box sx={{ mb: 3 }}>
        <AppBar position="static" color="transparent" elevation={0}>
          <Toolbar
            sx={{ justifyContent: "space-between", alignItems: "center" }}
          >
            <Box>
              <Typography
                variant="h5"
                component="h1"
                sx={{
                  color: Colors.primary,
                  fontWeight: 500,
                  letterSpacing: "1px",
                }}
              >
                TRAIN ROUTE
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary">
                TRAIN /TRAIN ROUTE
              </Typography>
            </Box>
          </Toolbar>
        </AppBar>
      </Box>

      <SimpleDialog
        open={editDialog}
        onClose={() => {
          setEditDialog(false);
        }}
        maxWidth={"md"}
        title="Edit Route"
      >
         <Box component="form" onSubmit={handleSubmit(EditTrainRoute)}>
            <Grid container spacing={3}>
              {/* Train Selection */}
              <Grid item xs={12} md={6}>
                <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
                  Train Name
                </Typography>
                <TextField
                fullWidth
                value={trainId?.TrainName}
                disabled
                InputProps={{
                  readOnly: true,
                }}
              />
               
              </Grid>

              {/* Station Details */}
              <Grid item xs={12} md={12} sm={12}>
                <Grid container spacing={2} alignItems="flex-end">
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body2"
                      sx={{ mb: 1, color: "#404e67" }}
                    >
                      Station Name
                    </Typography>
                    <TextField
                fullWidth
                {...register("stationName")}
                disabled
                InputProps={{
                  readOnly: true,
                }}
              />
                    {/* <Controller
                      name="stationName"
                      control={control}
                      rules={{
                        required: "Station Name is required",
                        validate: (value) => {
                          // Check if the selected station already exists in the stations array
                          if (
                            trainRoutes.some(
                              (station) =>
                                station.StationDetailsId ===
                                value?.StationDetailsId
                            )
                          ) {
                            return "This station already exists.";
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          options={stations}
                          getOptionLabel={(option) => option?.StationName || ""}
                          isOptionEqualToValue={(option, value) =>
                            option?.StationDetailsId === value?.StationDetailsId
                          }
                          value={field.value || null}
                          onChange={(_, value) => field.onChange(value || null)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              error={!!errors.stationName}
                              helperText={errors.stationName?.message}
                            />
                          )}
                        />
                      )}
                    /> */}
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body2"
                      sx={{ mb: 1, color: "#404e67" }}
                    >
                      Station Order Number
                    </Typography>
                    <TextField
                      fullWidth
                      type="number"
                      {...register("orderNo", {
                        required: "Station Order Number is required",
                        
                        // validate: (value) => {
                        
                        //   if (
                        //     trainRoutes.some(
                        //       (station) => station.OrderNumber === Number(value)
                        //     )
                        //   ) {
                        //     return "This Order Number already exists.";
                        //   }
                        //   return true;
                        // },
                      })}
                      error={!!errors.orderNo}
                      helperText={errors.orderNo?.message || ""}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body2"
                      sx={{ mb: 1, color: "#404e67" }}
                    >
                      Arrival Time
                    </Typography>
                    <TextField
                      fullWidth
                      type="time"
                      //   value={arrival}
                      //   onChange={(e) => setArrival(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      {...register("arrivalTime", {
                        required:
                          watch("orderNo") == 1 ? false : "Arrival Time is required", // Disable validation if orderNo is 1
                      })}
                      disabled={watch("orderNo") == 1}
                      error={!!errors.arrivalTime}
                      helperText={
                        errors.arrivalTime ? errors.arrivalTime.message : ""
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body2"
                      sx={{ mb: 1, color: "#404e67" }}
                    >
                      Departure Time
                    </Typography>
                    <TextField
                      fullWidth
                      type="time"
                      InputLabelProps={{ shrink: true }}
                      {...register("departureTime", {
                        required: "Departure Time is Required",
                      })}
                      error={!!errors.departureTime}
                      helperText={
                        errors.departureTime ? errors.departureTime.message : ""
                      }
                    />
                  </Grid>

                

                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body2"
                      sx={{ mb: 1, color: "#404e67" }}
                    >
                      Is Day Changed
                    </Typography>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={checkbox}
                          onChange={(e) => {
                            const isChecked = e.target.checked;
                            setCheckBox(isChecked);
                            if (!isChecked) setValue("dayCount", 0); // Set to 0 if unchecked
                          }}
                        />
                      }
                      label="Is Day Changed"
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body2"
                      sx={{ mb: 1, color: "#404e67" }}
                    >
                      Day Count
                    </Typography>
                    <TextField
                      fullWidth
                      type="number"
                      {...register("dayCount", {
                        required: "Day Count Number is Required",
                        validate: (value) => {
                          if (checkbox && ![1, 2, 3].includes(Number(value))) {
                            return "Only 1, 2, or 3 are allowed";
                          }
                          return true;
                        },
                      })}
                      disabled={!checkbox}
                      error={!!errors.dayCount}
                      helperText={errors.dayCount?.message}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={12}
                    sx={{ display: "flex", alignItems: "flex-end" }}
                  >
                    <Button
                      type="submit"
                      variant="contained"
                      sx={{
                        
                        height: "40px",
                        bgcolor: "#133e02",
                        "&:hover": {
                          bgcolor: "green.800",
                        },
                      }}
                    >
                    Update
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
      </SimpleDialog>

      <SimpleDialog
        open={deleteDialog}
        onClose={() => {
          setDeleteDialog(false);
        }}
      >
        <Typography variant="h6" sx={{ mb: 2, textAlign: "center" }}>
          Are you sure you want to Delete this Route?
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            gap: 2,
            mt: 3,
          }}
        >
          <Button
            sx={{ background: "grey", color: "white", px: 2.5 }}
            onClick={() => setDeleteDialog(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{ background: "rgb(0, 100, 0)" }}
            onClick={deleteTrainRoute}
          >
            Confirm
          </Button>
        </Box>
      </SimpleDialog>
      <Container
        maxWidth="xl"
        sx={{
          mt: 2,
          boxShadow: "0px 8px 24px 0 #4545501A",
          py: 2,
          backgroundColor: Colors.white,
          borderRadius: "12px",
        }}
      >
        <Box sx={{ width: "50%", mb: 1 }}>
          <Typography variant="body2" sx={{ mb: 1, color: "#404e67" }}>
            Train Name
          </Typography>
          <Controller
            name="trainName"
            control={control}
            rules={{ required: "Train Name is required" }}
            render={({ field }) => (
              <Autocomplete
                {...field}
                options={trains}
                getOptionLabel={(option) => option?.TrainName || ""}
                isOptionEqualToValue={(option, value) =>
                  option?.TrainId === value
                }
                value={
                  trains?.find((train) => train.TrainId === field.value) || null
                }
                onChange={(_, value) => {
                  field.onChange(value?.TrainId || "");
                  handleChange(value || "");
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    error={!!errors.trainName}
                    helperText={errors.trainName?.message}
                  />
                )}
              />
            )}
          />
        </Box>
        <TableContainer sx={{ height: "auto", overflowX: "auto" }}>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: "rgb(19 62 2)" }}>
                <TableCell sx={{ color: "white" }}>Order Number</TableCell>
                <TableCell sx={{ color: "white"}}>
                  Station Name
                </TableCell>
                <TableCell sx={{ color: "white" }}>
                  City
                </TableCell>
                <TableCell sx={{ color: "white" }}>
                  Arrival Time
                </TableCell>

                <TableCell sx={{ color: "white" }}>
                  Departure Time
                </TableCell>
                <TableCell sx={{ color: "white" }}>
                  Expected Delay
                </TableCell>
                <TableCell sx={{ color: "white" }}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <CircularProgress sx={{color:"#133e02"}} />
                  </TableCell>
                </TableRow>
              ) : (
                trainRoutes?.length > 0 ? (
                     trainRoutes?.map((train, index) => (
                       <TableRow key={train.LocomotiveId}>
                         <TableCell>{train?.OrderNumber}</TableCell>
                         <TableCell>{train.StationName}</TableCell>
                         <TableCell>{train.City}</TableCell>
                         <TableCell>
                           {train.ArrivalTime != null
                             ? moment(train.ArrivalTime, "HH:mm:ss").format(
                                 "hh:mm A"
                               )
                             : "0"}
                         </TableCell>
                         <TableCell>
                           {train.DepartureTime != null
                             ? moment(train.DepartureTime, "HH:mm:ss").format("hh:mm A" ): "0"}
                         </TableCell>
                         <TableCell>
                           {train.DelayInMinutes > 0 && train.DelayInMinutes < 60
                             ? `${train.DelayInMinutes} min`
                             : train.DelayInMinutes >= 60
                             ? timeDelays[index]
                             : "Right Time"}
                         </TableCell>
     
                         <TableCell>
                           <IconButton
                             aria-label="edit"
                             onClick={() => {
                               setEditDialog(true);
                               setSelectedTrain(train);
                             }}
                           >
                             <EditIcon />
                           </IconButton>
                           <IconButton
                             aria-label="delete"
                             onClick={() => {
                               setDeleteDialog(true);
                               setSelectedTrain(train);
                             }}
                           >
                             <DeleteIcon />
                           </IconButton>
                         </TableCell>
                       </TableRow>
                     )

                )
            ) :(
                <>
                <TableRow>
                  <TableCell colSpan={7} align="center">
                  <Typography sx={{display:"flex",justifyContent:'center' ,color:'#133e02'}}>
                    No Train Selected
                </Typography>
                  </TableCell>
                </TableRow>
               
                </>
            )
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </>
  );
}
